// extracted by mini-css-extract-plugin
module.exports = {"notification-badge":"Rodaz","notificationBadge":"Rodaz"};